import request from "@/common/request"
import { Page } from "@/models"
import { Romaneio, RomaneioForm } from "@/models/Romaneio"

const basePath = '/romaneio'

export const update = async (
	romaneio: RomaneioForm,
): Promise<void> => 
	request.put(`${basePath}`, romaneio)

export const salvarRomaneio = async (
	romaneioForm: RomaneioForm,
): Promise<any> => 
	request.post(`${basePath}`, romaneioForm)

export const findRomaneio = async (
	depositoId: string,
): Promise<Page<Romaneio>> => 
	request.get(`${basePath}/${depositoId}`)